import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'academy-court';
@Injectable({
    providedIn: 'root'
})
export class AcademyCourtService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getAcademyCourtList(query): Observable<any> {
        return this.http.get(API_URL + query, this.httpOptions);
    }
    getAcademyCourtDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id, this.httpOptions);
    }
    updateAcademyCourt(id, data): Observable<any> {
        return this.http.put(API_URL + '/' + id, data, this.httpOptions);
    }
    addAcademyCourt(data): Observable<any> {
        return this.http.post(API_URL, data, this.httpOptions);
    }
}